const LearningGoalRatingTypePolicy = {
  LearningGoalRating: {
    keyFields: ["id", "academicTerm"],
  },
};

export default LearningGoalRatingTypePolicy;
